const modTwoData = {
  module: 2,
  category: 'Frontend Fundamentals',
  days: [
    {
      link: "https://replit.com/@frontend-instructors/M2AdventDay1#index.js",
      emoji: "🍪"
    },
    {
      link: "https://github.com/turingschool-examples/receipt-comp",
      emoji: "🧾"
    },
    {
      link: "https://github.com/turingschool-examples/get-some-gifts",
      emoji: "🎁"
    },
    {
      link: "https://github.com/turingschool-examples/treehouse-driven-development",
      emoji: "🏡"
    },
    {
      link: "https://replit.com/@frontend-instructors/winter-activities#index.js",
      emoji: "⛷️"
    },
    {
      link: "https://github.com/turingschool-examples/post-a-gift",
      emoji: "✉️"
    },
    {
      link: "https://turingschool.notion.site/Advent-Theme-Rest-Day-Notes-63c185f90901476b80ecc9c73045bb2b?pvs=4",
      emoji: "😌"
    },
    {
      link: "https://github.com/turingschool-examples/kitchen-clean-up",
      emoji: "👩‍🍳"
    },
    {
      link: "https://replit.com/@frontend-instructors/spicy-soup#index.js",
      emoji: "🍲"
    },
    {
      link: "https://github.com/turingschool-examples/packing-list",
      emoji: "🧳"
    }
  ]
};

export default modTwoData;
